module.exports = __webpack_public_path__ + "static/media/article6.c2459cb6.webp";